/**
 * Module popin
 *
 * Easy way to create popin or popover
 *
 */

'use strict';

const _ = require('lodash');

const Popin = require('./popin');

let popins = [];

module.exports.createPopin = function(config) {
    let popin = new Popin(config);

    popins.push(popin);

    return popin;
};

module.exports.getAll = function() {
    return popins;
};

module.exports.removePopin = function(popin) {
    _.forEach(popins, function(current, key) {
        if (current === popin) {
            delete popins[key];
        }
    });

    popins = _.filter(popins);
};
